"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.modelCanRun = modelCanRun;
exports.activityDistance = activityDistance;
exports.carbonEmissions = carbonEmissions;
exports.modelCanRunVersion = exports.explanation = exports.modelVersion = exports.modelName = void 0;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));

var _d3Geo = require("d3-geo");

var _definitions = require("../../definitions");

var _utils = require("../utils");

var _airports = require("./airports");

var _loadfactors = _interopRequireDefault(require("./loadfactors.json"));

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(source, true).forEach(function (key) { (0, _defineProperty2["default"])(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(source).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

// Constants for JSON keys
var ICAO_REGION_KEY = 'icao_region_code';
var PASSENGER_LOAD_FACTORS_KEY = 'passenger_load_factors';
var PASSENGER_FREIGHT_RATIO_KEY = 'passenger_to_freight_ratio';
var modelName = 'flight';
exports.modelName = modelName;
var modelVersion = '2';
exports.modelVersion = modelVersion;
var explanation = {
  text: 'Calculations take into account direct emissions from burning fuel and manufacturing of vehicle. They are based on international statistics on passenger and cargo loads and aircraft type usage.',
  links: [{
    label: 'My Climate (2019)',
    href: 'https://www.myclimate.org/fileadmin/user_upload/myclimate_-_home/01_Information/01_About_myclimate/09_Calculation_principles/Documents/myclimate-flight-calculator-documentation_EN.pdf'
  }, {
    label: 'ICCT Report (2018)',
    href: 'https://theicct.org/sites/default/files/publications/ICCT_CO2-commercl-aviation-2018_20190918.pdf'
  }]
};
exports.explanation = explanation;
var modelCanRunVersion = 1;
exports.modelCanRunVersion = modelCanRunVersion;

function modelCanRun(activity) {
  var activityType = activity.activityType,
      transportationMode = activity.transportationMode,
      distanceKilometers = activity.distanceKilometers,
      endDatetime = activity.endDatetime,
      departureAirportCode = activity.departureAirportCode,
      destinationAirportCode = activity.destinationAirportCode;

  if (activityType === _definitions.ACTIVITY_TYPE_TRANSPORTATION && transportationMode === _definitions.TRANSPORTATION_MODE_PLANE && (distanceKilometers || endDatetime || departureAirportCode && destinationAirportCode)) {
    return true;
  }

  return false;
} // Key constants used in the model
// source: https://www.myclimate.org/fileadmin/user_upload/myclimate_-_home/01_Information/01_About_myclimate/09_Calculation_principles/Documents/myclimate-flight-calculator-documentation_EN.pdf


var shortHaulDistanceThreshold = 1500; // km

var longHaulDistanceThreshold = 2500; // km

var defaultPassengerLoadFactor = 0.82; // i.e. 77% of seats occupied on average

var fuelCo2Intensity = 3.15; // kgCO2 per kg jet Fuel

var fuelPreProductionCo2Intensity = 0.54; // kgCO2eq per kg jet fuel

var radiativeForcingMultiplier = 2; // accounts for non-CO2 effect in high altitude (uncertain parameter between 1.5 and 4)

var aircraftFactor = 0.00038; // accounts for aircrafts using produced, then maintained and at the end of their life disposed.

var detourConstant = 95; // km

var airportinfrastructureFactor = 11.68; // accounts for using the airport infrastructure

var bookingClassWeightingFactor = function bookingClassWeightingFactor(bookingClass, isShortHaul) {
  // TODO(bl): use constants in sources to improve matching probability
  switch (bookingClass) {
    case 'business':
      return isShortHaul ? 1.26 : 1.54;

    case 'first':
      return 2.4;

    default:
      return isShortHaul ? 0.96 : 0.8;
    // assumed economy class by default
  }
}; // long/short-haul dependent constants


var defaultPassengerToFreightRatio = function defaultPassengerToFreightRatio(isShortHaul) {
  return isShortHaul ? 0.93 : 0.74;
}; // Passenger aircrafts often transport considerable amounts of freight and mail,
// in particular in wide-body aircrafts on long-haul flights.


var averageNumberOfSeats = function averageNumberOfSeats(isShortHaul) {
  return isShortHaul ? 153.51 : 280.21;
};

var a = function a(isShortHaul) {
  return isShortHaul ? 0 : 0.0001;
}; // empiric fuel consumption parameter


var b = function b(isShortHaul) {
  return isShortHaul ? 2.714 : 7.104;
}; // empiric fuel consumption parameter


var c = function c(isShortHaul) {
  return isShortHaul ? 1166.52 : 5044.93;
}; // empiric fuel consumption parameter


function airportIataCodeToRegion(iata) {
  if (!_airports.airports[iata]) {
    throw new Error("Unknown airport code ".concat(iata));
  }

  return _airports.airports[iata][ICAO_REGION_KEY];
}

function airportIataCodeToCoordinates(iata) {
  if (!_airports.airports[iata]) {
    throw new Error("Unknown airport code ".concat(iata));
  }

  return {
    latitude: _airports.airports[iata].lonlat[1],
    longitude: _airports.airports[iata].lonlat[0]
  };
}

function distanceFromAirports(airportCode1, airportCode2) {
  return (0, _d3Geo.geoDistance)([airportIataCodeToCoordinates(airportCode1).longitude, airportIataCodeToCoordinates(airportCode1).latitude], [airportIataCodeToCoordinates(airportCode2).longitude, airportIataCodeToCoordinates(airportCode2).latitude]) * 6371 + // To convert great-arc distance (in radians) into km.
  detourConstant;
}

function averageSpeedFromDuration(hour) {
  // Adapted from https://airasia.listedcompany.com/images/ir-speed-length_7.gif, could be improved!
  if (hour < 3.3) {
    return 14.1 + 495 * hour - 110 * hour * hour + 9.85 * hour * hour * hour - 0.309 * hour * hour * hour * hour;
  }

  return 770;
}

function distanceFromDuration(hour) {
  return averageSpeedFromDuration(hour) * hour;
}

function emissionsForShortOrLongHaul(distance, bookingClass, passengerLoadFactor, passengerToFreightRatio, isShortHaul) {
  return (a(isShortHaul) * distance * distance + b(isShortHaul) * distance + c(isShortHaul)) / (averageNumberOfSeats(isShortHaul) * passengerLoadFactor) * passengerToFreightRatio(isShortHaul) * bookingClassWeightingFactor(bookingClass, isShortHaul) * (fuelCo2Intensity * radiativeForcingMultiplier + fuelPreProductionCo2Intensity) + aircraftFactor * distance + airportinfrastructureFactor;
}

function emissionsBetweenShortAndLongHaul(distance, bookingClass, passengerLoadFactor, passengerToFreightRatio) {
  // Formula for inbetween short and long haul is a linear interpolation between
  // both hauls
  var eMin = emissionsForShortOrLongHaul(shortHaulDistanceThreshold, bookingClass, passengerLoadFactor, passengerToFreightRatio, true);
  var eMax = emissionsForShortOrLongHaul(longHaulDistanceThreshold, bookingClass, passengerLoadFactor, passengerToFreightRatio, false); // x is between 0 (short haul) and 1 (long haul)

  var x = (distance - shortHaulDistanceThreshold) / (longHaulDistanceThreshold - shortHaulDistanceThreshold);
  return (1 - x) * eMin + x * eMax;
}

function computeFootprint(distance, bookingClass, passengerLoadFactor, passengerToFreightRatio) {
  if (distance < shortHaulDistanceThreshold || distance > longHaulDistanceThreshold) {
    // Flight is eigher short or long (but not in between)
    var isShortHaul = distance < shortHaulDistanceThreshold;
    return emissionsForShortOrLongHaul(distance, bookingClass, passengerLoadFactor, passengerToFreightRatio, isShortHaul);
  }

  return emissionsBetweenShortAndLongHaul(distance, bookingClass, passengerLoadFactor, passengerToFreightRatio);
}

function getLoadFactors(activity) {
  if (activity.departureAirportCode && activity.destinationAirportCode) {
    var departureAirportRegion = airportIataCodeToRegion(activity.departureAirportCode);
    var destinationAirportRegion = airportIataCodeToRegion(activity.destinationAirportCode);

    if (departureAirportRegion && destinationAirportRegion && Object.keys(_loadfactors["default"][departureAirportRegion][PASSENGER_LOAD_FACTORS_KEY]).includes(destinationAirportRegion)) {
      return [_loadfactors["default"][departureAirportRegion][PASSENGER_LOAD_FACTORS_KEY][destinationAirportRegion] / 100, // normal form of passenger to freight ratio is function of isshorthaul
      function () {
        return _loadfactors["default"][departureAirportRegion][PASSENGER_FREIGHT_RATIO_KEY][destinationAirportRegion] / 100;
      }];
    }
  }

  return [defaultPassengerLoadFactor, defaultPassengerToFreightRatio];
}

function activityDistance(activity) {
  if (activity.departureAirportCode && activity.destinationAirportCode) {
    // compute distance from airport codes
    return distanceFromAirports(activity.departureAirportCode, activity.destinationAirportCode);
  }

  if (activity.distanceKilometers && activity.distanceKilometers > 50) {
    // we trust the activity's distance
    return activity.distanceKilometers;
  } // If no airport code is available, and no distance is trusteable
  // therefore, compute distance based on duration


  var durationHours = (0, _utils.getActivityDurationHours)(activity);

  if (!durationHours) {
    throw new Error("Invalid durationHours with datetime = ".concat(activity.datetime, " and endDatetime = ").concat(activity.endDatetime));
  }

  return distanceFromDuration(durationHours);
}

function calculateEmissions(activity) {
  var distance = activityDistance(activity);

  var _getLoadFactors = getLoadFactors(activity),
      _getLoadFactors2 = (0, _slicedToArray2["default"])(_getLoadFactors, 2),
      passengerLoadFactor = _getLoadFactors2[0],
      passengerToFreightRatio = _getLoadFactors2[1];

  if (!Number.isFinite(distance)) {
    throw new Error("Incorrect distance obtained: ".concat(distance));
  }

  if (!Number.isFinite(passengerLoadFactor)) {
    throw new Error("Incorrect load factor obtained: ".concat(passengerLoadFactor));
  }

  if (!Number.isFinite(passengerToFreightRatio(true)) || !Number.isFinite(passengerToFreightRatio(false))) {
    throw new Error("Incorrect passenger freight ratio obtained: short haul: ".concat(passengerToFreightRatio(true), ", long haul: ").concat(passengerToFreightRatio(false)));
  }

  return computeFootprint(distance, activity.bookingClass, passengerLoadFactor, passengerToFreightRatio);
}
/*
  Calculates emissions in kgCO2eq
*/


function carbonEmissions(activity) {
  var departureAirportCode = activity.departureAirportCode,
      destinationAirportCode = activity.destinationAirportCode,
      isRoundtrip = activity.isRoundtrip;
  var footprint = calculateEmissions(activity);

  if (!isRoundtrip) {
    return footprint;
  } // If no airport codes are defined, we simply multiply the emissions for roundtrips


  if (!departureAirportCode || !destinationAirportCode) {
    return footprint * 2;
  } // Reversing the destination and departure to calculate more precise emissions


  var returnActivity = _objectSpread({}, activity, {
    departureAirportCode: destinationAirportCode,
    destinationAirportCode: departureAirportCode
  });

  return footprint + calculateEmissions(returnActivity);
}